var app = angular.module('leonardo');

var WPFormDateTime = function ($timeout) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      defaultNow: '@',
      startDate: '@',
      endDate: '@',
      timeInterval: '=?'
    },
    templateUrl: 'views/templates/form/form-datetime.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.init = false;

      if (attrs.validatorRequired || scope.required) {
        scope.required_validator = true;
      }

      scope.ngModelCtrl.$render = function () {
        var value = scope.ngModelCtrl.$modelValue;
        if (!value) {
          scope.date = null;
          scope.time = null;
        } else {
          var m = moment(value);
          scope.date = m.format('YYYY-MM-DD');
          scope.time = m.format('HH:mm');
        }
        $timeout(function () {
          scope.init = true;
        }, 0);
      };

      scope.setStartDate = function (startDate) {
        scope.startDay = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        if (!scope.date || scope.date <= scope.startDay) {
          scope.startHour = startDate ? moment(startDate).format('HH:mm') : null;
        } else {
          scope.startHour = null;
        }
      };

      scope.setEndDate = function (startDate) {
        scope.endDay = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        if (!scope.date || scope.date >= scope.endDay) {
          scope.endHour = startDate ? moment(startDate).format('HH:mm') : null;
        } else {
          scope.endHour = null;
        }
      };

      scope.$watch('startDate', function (newValue) {
        scope.setStartDate(newValue);
      });

      scope.$watch('endDate', function (newValue) {
        scope.setEndDate(newValue);
      });

      scope.$watch('date', function (newValue) {
        if (scope.init) {
          scope.setValue(newValue, scope.time);
          scope.ngModelCtrl.$validate();
        }
      });

      scope.$watch('time', function (newValue) {
        if (scope.init) {
          scope.setValue(scope.date, newValue);
          scope.ngModelCtrl.$validate();
        }
      });

      scope.setValue = function (date, time) {
        if (!date || !time) {
          scope.ngModelCtrl.$setViewValue(undefined);
          return;
        }
        var m = moment(date + ' ' + time, 'YYYY-MM-DD HH:mm');
        scope.ngModelCtrl.$setViewValue(m.format());
        scope.setStartDate(scope.startDate);
        scope.setEndDate(scope.endDate);
      };

      scope.ngModelCtrl.$validators.date_or_time_missing = function () {
        if (!scope.required_validator) {
          return true;
        } else if (scope.date && !scope.time) {
          return false;
        } else if (!scope.date && scope.time) {
          return false;
        }
        return true;
      };
    }
  };
};

app.directive('wpFormDateTime', ['$timeout', WPFormDateTime]);
